import type { FC } from 'react'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import type { GoogleTagManagerProps } from './GoogleTagManager.interface'
import { gtmId, pushToDataLayer } from '~/features/infra/gtm'

const pageview = (url: string): void => {
  pushToDataLayer({
    event: 'RouteChange',
    pageUrl: url
  })
}

const handleRouteChange = (url: string): void => {
  pageview(url)
}

export const GoogleTagManager: FC<GoogleTagManagerProps> = ({ children }) => {
  const router = useRouter()

  useEffect(() => {
    const isPreview = router?.isPreview

    if (gtmId && !isPreview) {
      router.events.on('routeChangeComplete', handleRouteChange)
    }

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router])

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}

export { pushToDataLayer }
